exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "pre {\n  font-size: .8rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/shared/components/codeblock/codeblock.component.scss
// module id = ../../../../../src/app/shared/components/codeblock/codeblock.component.scss
// module chunks = main